import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import JustificationModal from '@components/JustificationModal';

import { getAdministrators, deleteAdmin } from '@actions/admins';
import { validatePermissionAction } from '@actions/sessionPermission';
import { sendActionToBitacora  } from '@actions/bitacora';

import { StatusString } from '@constants/general'
import catalogPermissionsId from '@constants/catalogPermissionsId';

import { getValueLanguageObj } from '@utils/general'


class Administrators extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loading: false,
      totalRecords: 0,
      lazyParams: {
        first: 0,
        rows: 10,
        page: 0,
      },
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
      searchValues: {
        rol: null,
        profile: null,
        find: '',
      },
    }
  }

  componentDidMount() {
    this.loadData();
  }

  showDeleteUser = async (detail) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea eliminar {{ELEMENTO}}?', {ELEMENTO: detail.nombre}),
        continueAction: ({justification}) => this.onDeleteAdmin(detail, justification),
      },
    });
  };

  onDeleteAdmin = async (data, justification) => {
    const { t, deleteAdmin, sendActionToBitacora } = this.props;
    this.setState({loading: true})
    const response = await deleteAdmin({...data, justification});
    if (!response?.response) {
      const dataBitacora = {
        transactionName: 'bajaAdmin',
        reason: `${data.correo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData();
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    this.setState({loading: false})
  }

  updateAdmin = async (data) => {
    const { history } = this.props
    return history.push({pathname: '/admin/edit', state: {user: {...data}}})
  }

  loadData = async () => {
    const { getAdministrators, t } = this.props;
    this.setState({ loading: true });
    const response = await getAdministrators();
    if (!response?.status) {
      return this.setState({
        totalRecords: response.data.lenght,
        users: response.data,
        loading: false,
      });
    }
    if (response?.status && response?.status === 404) {
      return this.setState({
        totalRecords: 0,
        users: [],
        loading: false,
      });
    }
    confirmDialog({
      message: response.data.acknowledgementDescription,
      header: t('Ha ocurrido un error'),
      icon: `pi pi-exclamation-triangle`,
      acceptLabel: t('Cerrar'),
      rejectClassName: 'hide-component',
      accept: () => {},
    });
    return this.setState({ loading: false });
  };

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    console.log('event onPage', event);
    this.setState({ lazyParams: _lazyParams }, this.loadData);
  };

  onSort = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    console.log('event onSort', event);
    this.setState({ lazyParams: _lazyParams });
  };

  onChangeSearch = (e) => {
    console.log(e);
    const { searchValues } = this.state;
    this.setState({
      searchValues: { ...searchValues, [e.target.name]: e.value },
    });
  };

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  deleteUser = () => {
    // TODO Eliminar usuario
    this.toast.show({
      severity: 'success',
      summary: 'Eliminar usuario',
      detail: 'Se ha eliminado el usuario',
      life: 3000,
    });
  };

  editAdmin = (data) => {
    const { history } = this.props
    history.push({pathname: "/admin/edit", state: { ...data }})
  }

  columnResponsive = (rowData, detail) => (
      <>
          <span className="p-column-title">{detail.header}</span>
          {rowData[detail.field]}
      </>
    )
  
  countryTemplate = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {getValueLanguageObj(JSON.parse(rowData.pais))}
    </>
  )

  perfilesTemplate = (rowData, detail) => {
    const getPerfil = rowData.perfiles.map(item => getValueLanguageObj(JSON.parse(item.nombre)))
    const perfil = getPerfil.join(',')
    return (
      <>
          <span className="p-column-title">{detail.header}</span>
          {perfil}
      </>
    )
  }

  adminsTemplate = (rowData, detail) => {
    const { t } = this.props
    if (rowData?.admin_paises === "ALL") return (
      <>
          <span className="p-column-title">{detail.header}</span>
          {t('Todos los países')}
      </>
    )
    const getCountries = rowData.paises.map(item => getValueLanguageObj(JSON.parse(item.nombre)))
    const countries = getCountries.join(',')
    return (
      <>
          <span className="p-column-title">{detail.header}</span>
          {countries}
      </>
    )
  }

  statusTemplate = (node, detail) => {
    const { t } = this.props
    if (node.estatus === StatusString.STATUS_SUSPENDED) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red" aria-hidden="true"> {t('Suspendido').toUpperCase()} </span>
        </>
      );
    }
    if (node.estatus === StatusString.STATUS_ACTIVE) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span  aria-hidden="true"> {t('Activo')} </span>
        </>
      );
    }
  }

  deleteTemplate = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      <Button
        icon="pi pi-trash"
        className=" p-button-text p-button-primary p-mr-2"
        onClick={() => this.showDeleteUser(rowData)}
      />
    </>
  );

  editTemplate = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      <Button
        icon="pi pi-pencil"
        className=" p-button-text p-button-primary p-mr-2"
        onClick={() => this.editAdmin(rowData)}
      />
    </>
  );

  render() {
    const { t, history, validatePermissionAction } = this.props
    const {
      searchValues,
      showModalJustification,
      users,
      lazyParams,
      totalRecords,
      loading,
    } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        { validatePermissionAction(catalogPermissionsId.CREAR_ADMINISTRADORES) && (
          <Button
            label={t('Agregar administrador')}
            className="p-button-primary"
            onClick={() => history.push({pathname: '/admin/new', state: { clearCache: true }})}
          />
        )}
      </>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title="Administradores" rightComponent={rightHeader} />
          <div className="card">
            <div className="p-grid">
              <div className="p-col-12">

              </div>
              <div className="p-col-12">
                <DataTable
                  value={users}
                  lazy
                  // paginator
                  // first={lazyParams.first}
                  // rows={1}
                  // totalRecords={totalRecords}
                  // onPage={this.onPage}
                  // onSort={this.onSort}
                  loading={loading}
                  className="table-section-list"
                >
                  <Column header={t("Pais")} body={this.countryTemplate} />
                  <Column field="empresa" header={t("Empresa")} body={this.columnResponsive} />
                  <Column field="nombre" header={t("Nombre")} body={this.columnResponsive} />
                  <Column field="fc_telefono" header={t("Perfil(es)")} body={this.perfilesTemplate} />
                  <Column header={t("Administra")} body={this.adminsTemplate} />
                  <Column header={t("Estatus")} body={this.statusTemplate} />
                  { validatePermissionAction(catalogPermissionsId.AJUSTAR_INFORMACION_ADMINISTRADORES) && (
                    <Column header={t("Editar")} body={this.editTemplate} />
                  )}
                  { validatePermissionAction(catalogPermissionsId.ELIMINAR_ADMINISTRADORES) && (
                    <Column header={t("Eliminar")} body={this.deleteTemplate} className="column-action p-text-center-lg"/>
                  )}
                </DataTable>
              </div>
              { !users.length && (
                <div className="p-col-12 not-information">
                  {t('No se encontraron resultados')}
                </div>
              )
              }
            </div>
          </div>
        </div>
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
        <Toast ref={(el) => (this.toast = el)} />
      </div>
    );
  }
}

const mapDispatchToProps = {
  getAdministrators,
  deleteAdmin,
  validatePermissionAction,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(null, mapDispatchToProps)
  )(Administrators);
